import { Button, Container, Flex, Heading, Text, TextField } from "@radix-ui/themes"
import React, { useEffect, useMemo, useState } from "react"
import useFetch from "../../core/hooks/useFetch"
import UserService from "../../core/services/UserService"
import { toast, ToastContainer } from "react-toastify"
export default function ResetPassword() {
    const [email, setEmail] = useState<string>('')

    const [fetchResetPassword, isLoading, error, errors] = useFetch(async () => {
        const data = await UserService.ResetPasswordRequest(email)
        toast.success(data.message)
    })
    useEffect(() => {
       if(error.length) toast.error(error)
    }, [error])
    return (
        <Container className="p-5">
            <ToastContainer />
               <Container className="heading-reset-password">
                    <Heading>
                        Восстановление пароля
                    </Heading>
                </Container>
        <Flex justify={'center'} direction={'column'} gap={'3'} className="pt-5">
            <Flex gap={'3'} direction={'column'}>
                <Text>Емейл</Text>
                <TextField.Root placeholder="Емейл" value={email} onChange={e => setEmail(e.target.value)}>
                    <TextField.Slot>

                    </TextField.Slot>
                </TextField.Root>
            </Flex>
            <Button loading={isLoading} onClick={async () => fetchResetPassword()}>
                Отправить
            </Button>
        </Flex>
    </Container>
    )
}